(function() {
  const quantityAndATCButton = `<div class="cf-atc-container">
                                  <div class="atc-quantity-wrapper">
                                     <p class="atc-quantity-label">QUANTITY</p>
                                      <div class="atc-qty-inner">
                                          <img class="qty-decrease" src="https://cdn.shopify.com/s/files/1/2013/0229/files/left_black-caret.png?v=1719924569" alt="blj-assets">
                                          <p class="cf-qty-display">1</p>
                                          <img class="qty-increase" src="https://cdn.shopify.com/s/files/1/2013/0229/files/right_black_caret.png?v=1719924569" alt="blj-assets">
                                      </div>
                                  </div>
                                  <div class="cf-atc-button" role="button" focusable="true" tabindex="0">${theme.preOrderButton}</div>
                                </div>`;
  
  function addContent(){
	  //If there is a variation insert the quantityATCButton after that div
	  let variation = $("#nt_variations");
	  if (variation.length > 0) {
	    $(variation).after(quantityAndATCButton);
	  } else {
		$("#cart-form").prepend(quantityAndATCButton);
      }
      
      incrementOrDecrementInput();
      newATCButton();
  }
  
  const incrementOrDecrementInput = () => {
      let qtyDecrease = document.querySelector("img.qty-decrease");
      let qtyIncrease = document.querySelector("img.qty-increase");
      qtyDecrease.addEventListener("click", () => {
        let display = parseInt($(".cf-qty-display").text());
		if (display > 1) {
      $("#shopify_quantity input.minus").click();
		  let newDisplay = display - 1;
		  $(".cf-qty-display").text(newDisplay);
		}
      });
      qtyIncrease.addEventListener("click", () => {
        $("#shopify_quantity input.plus").click();
        let display = parseInt($(".cf-qty-display").text());
        let newDisplay = display + 1;
        $(".cf-qty-display").text(newDisplay);
      });
    };
  
    const newATCButton = () => {
      let newATCButton = document.querySelector(".cf-atc-button");
      newATCButton.addEventListener("click", () => {
        $("#shopify_add_to_cart").click();
      });
    };

   $(document).ready(function() {
		addContent();
   });
  
})()